/**
 * Vista Mis Campañas — embudo DESGLOSADO por campaña (utm_source/utm_campaign).
 * Por cada anuncio: cuántos captó, cuántos recargaron, cuántos jugaron. El
 * promotor ve qué pauta convierte mejor para invertir donde rinde. Read-only.
 * Consume GET /api/cashier/campanas?desde=&hasta=.
 */

import { t } from '../languages.js';
import { rangoPorDefecto } from './_helpers.js';
import { renderChipsFecha } from './chips-fecha.js';
import { renderSeccionCanales } from './seccion-canales.js';

// Los UTM vienen del link (input del usuario) — escapar antes de pintarlos.
function esc(s) {
    return String(s == null ? '' : s).replace(
        /[&<>"']/g,
        c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
    );
}

export function renderCampanas({ apiGet }) {
    const el = document.createElement('div');
    const { desde, hasta } = rangoPorDefecto();

    el.innerHTML = `
        <div class="card-hero" style="margin-bottom:2px;">
            <span class="hero-num" id="pm-camp-total">0</span>
            <div class="hero-label">${t('campanas.titulo')}</div>
        </div>
        <div class="card">
            <h2>${t('campanas.titulo')}</h2>
            <p style="color:var(--text-dim); font-size:15px; margin:0 0 12px; line-height:1.35;">${t('campanas.descripcion')}</p>
            <div class="date-range">
                <input type="date" id="pm-desde" value="${desde}" aria-label="${t('common.desde')}">
                <input type="date" id="pm-hasta" value="${hasta}" aria-label="${t('common.hasta')}">
            </div>
            <div id="pm-campanas-body">
                <div style="text-align:center; color:var(--text-dim); padding:18px;">${t('common.cargando')}</div>
            </div>
        </div>`;

    const body = el.querySelector('#pm-campanas-body');
    const totalEl = el.querySelector('#pm-camp-total');
    const desdeEl = el.querySelector('#pm-desde');
    const hastaEl = el.querySelector('#pm-hasta');

    const chips = renderChipsFecha({ desdeEl, hastaEl, onChange: () => recargarTodo() });
    desdeEl.closest('.date-range').insertAdjacentElement('beforebegin', chips);

    // Sección "Por dónde te entran" (estadística por CANAL de compartir) — arriba
    // de las campañas de pauta. Comparte el rango de fechas (mismos inputs).
    const seccionCanales = renderSeccionCanales({
        apiGet,
        getRango: () => ({ desde: desdeEl.value, hasta: hastaEl.value }),
    });
    el.insertBefore(seccionCanales.el, el.firstChild);

    let cargando = false;
    async function cargar() {
        if (cargando) return;
        cargando = true;
        body.innerHTML = `<div style="text-align:center; color:var(--text-dim); padding:24px;">${t('common.cargando')}</div>`;
        const r = await apiGet(`/api/cashier/campanas?desde=${desdeEl.value}&hasta=${hastaEl.value}`);
        cargando = false;
        if (!r || r.ok === false) {
            body.innerHTML = `<div style="text-align:center; color:var(--danger); padding:24px;">${(r && r.mensaje) || t('common.reintentar')}</div>`;
            return;
        }
        const campanas = r.campanas || [];
        if (totalEl) totalEl.textContent = String(campanas.length);
        if (campanas.length === 0) {
            body.innerHTML = `<div style="text-align:center; color:var(--text-dim); padding:24px;">${t('campanas.sinDatos')}</div>`;
            return;
        }

        // Cada campaña en una CARD grande con sus 3 métricas visibles.
        body.innerHTML = campanas
            .map(c => {
                const captados = c.captados || 0;
                const pctRecarga = captados > 0 ? Math.round((c.con_recarga / captados) * 100) : 0;
                const pctJuego = captados > 0 ? Math.round((c.con_apuesta / captados) * 100) : 0;
                return `
                <div class="pm-camp-card">
                    <div class="pm-camp-nombre">${esc(c.utm_campaign)}</div>
                    <div class="pm-camp-source">${esc(c.utm_source)}</div>
                    <div class="pm-camp-metricas">
                        <div class="pm-camp-metrica">
                            <div class="pm-camp-num">${captados}</div>
                            <div class="pm-camp-label">${t('campanas.captados')}</div>
                        </div>
                        <div class="pm-camp-metrica">
                            <div class="pm-camp-num" style="color:var(--success);">${c.con_recarga || 0}</div>
                            <div class="pm-camp-label">${t('campanas.recargaron')} · ${pctRecarga}%</div>
                        </div>
                        <div class="pm-camp-metrica">
                            <div class="pm-camp-num" style="color:var(--warning);">${c.con_apuesta || 0}</div>
                            <div class="pm-camp-label">${t('campanas.jugaron')} · ${pctJuego}%</div>
                        </div>
                    </div>
                </div>`;
            })
            .join('');
    }

    // Al cambiar el rango, recargar campañas Y la sección de canales.
    function recargarTodo() {
        cargar();
        seccionCanales.recargar();
    }
    desdeEl.addEventListener('change', recargarTodo);
    hastaEl.addEventListener('change', recargarTodo);
    cargar();

    return el;
}
